import { render, staticRenderFns } from "./ColourSwatches.vue?vue&type=template&id=746c56a8&scoped=true&"
import script from "./ColourSwatches.js?vue&type=script&lang=js&"
export * from "./ColourSwatches.js?vue&type=script&lang=js&"
import style0 from "./ColourSwatches.scss?vue&type=style&index=0&id=746c56a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c56a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
